import { z } from "zod";
import { IsoDateTime, OpaqueId } from "./common.js";
/**
 * Assistant IA admin (v1.56, demande utilisateur 2026-09-19) — chat Claude
 * branché sur les données réseau en direct, réservé à un compte admin
 * précisément désigné (`config.assistant.allowedAdminUsernames`, côté
 * serveur uniquement — jamais exposé au front). L'assistant n'a accès qu'à
 * des outils de lecture qui rejouent les mêmes routes GET consultatives déjà
 * exposées ailleurs ; **il ne peut structurellement rien modifier** —
 * prolongement direct du principe CDC « Sentinelle conseille, n'agit pas ».
 *
 * `GET /auth/me` porte `assistantEnabled` (booléen dérivé côté serveur) pour
 * que le front n'ait jamais à coder un nom de compte en dur.
 */
/** Un appel d'outil fait par l'assistant pendant ce tour — affordance de transparence, pas le résultat brut. */
export const AssistantToolCall = z.object({
    name: z.string(),
    input: z.record(z.string(), z.unknown()),
});
export const AssistantMessageRole = z.enum(["user", "assistant"]);
/** Vue simplifiée d'un tour, pour l'affichage — pas les blocs bruts de l'API Anthropic (persistés côté serveur uniquement, pour rejeu). */
export const AssistantMessage = z.object({
    id: OpaqueId,
    role: AssistantMessageRole,
    text: z.string(),
    /** Outils consultés pour produire CE tour — absent/vide si aucun, jamais sur un tour `user`. */
    toolCalls: z.array(AssistantToolCall).default([]),
    createdAt: IsoDateTime,
});
export const AssistantConversation = z.object({
    id: OpaqueId,
    title: z.string().nullable(),
    createdAt: IsoDateTime,
    updatedAt: IsoDateTime,
});
export const AssistantConversationsResponse = z.object({
    conversations: z.array(AssistantConversation),
});
export const AssistantConversationDetailResponse = z.object({
    conversation: AssistantConversation,
    messages: z.array(AssistantMessage),
});
export const AssistantChatRequest = z.object({
    /** `null` démarre une nouvelle conversation. */
    conversationId: OpaqueId.nullable(),
    message: z.string().min(1).max(4000),
});
export const AssistantChatResponse = z.object({
    conversationId: OpaqueId,
    message: AssistantMessage,
});
//# sourceMappingURL=assistant.js.map